module.exports = __webpack_public_path__ + "3e61cd37d853ebd2479772f55cc6e081.svg";